export enum Client {
    Advance = 'advance',
    Basic = 'basic',
    Free = 'free',
    MfConsulting = 'mfconsulting',
    Other = 'other',
    Toxxip = 'toxxip'
}
